import { useEffect, useState } from "react";
import { MonitorDown, Share } from "lucide-react";
import { track } from "@/lib/tracking";

const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [hidden, setHidden] = useState(() => isStandalone() || localStorage.getItem("fs_install_dismissed") === "1");

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => { setHidden(true); track("pwa_installed", {}); });
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (hidden || (!deferred && !isIos())) return null;

  const install = async () => {
    track("pwa_install_clicked", {});
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setHidden(true);
    setDeferred(null);
  };
  const dismiss = () => { localStorage.setItem("fs_install_dismissed", "1"); setHidden(true); };

  return (
    <section data-testid="install-prompt" className="mt-8 flex items-center gap-4 border border-[#E6DFD5] bg-[#F4F1EC] p-4 sm:p-5">
      <img src="/icon-192.png" alt="" className="w-14 h-14 rounded-2xl border border-[#E6DFD5] shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-serif text-lg leading-tight">Tieni la tua routine a portata di mano</p>
        {deferred ? (
          <p className="text-xs text-[#595652] mt-1">Salva FineSkin sul desktop o sulla schermata Home: la ritroverai con un tocco.</p>
        ) : (
          <p className="text-xs text-[#595652] mt-1 flex items-center gap-1 flex-wrap">Su iPhone: tocca <Share size={12} className="inline" /> Condividi e poi “Aggiungi alla schermata Home”.</p>
        )}
      </div>
      {deferred && (
        <button data-testid="install-pwa-btn" onClick={install} className="fs-btn !py-2.5 !px-4 text-xs shrink-0"><MonitorDown size={14} /> Salva</button>
      )}
      <button data-testid="install-dismiss-btn" onClick={dismiss} aria-label="Chiudi" className="text-[#8C8275] hover:text-[#1A1A18] text-xs shrink-0">✕</button>
    </section>
  );
};
